import type { IxcProxyvoteV1ProxyTaskKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const PROXYVOTE_TASK_BASE_PATH = getResolvedPath('/clearing/vendor/beta-nxt/proxy-vote-task');

export const getProxyVoteTaskPath: EntityPathBuilder<IxcProxyvoteV1ProxyTaskKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return PROXYVOTE_TASK_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.taskId) {
        return undefined;
      }

      return getResolvedPath(`${PROXYVOTE_TASK_BASE_PATH}/$taskId`, context.keys);
    }
  }
};

export function getProxyVoteTaskDetailPath(taskId: string | undefined) {
  if (!taskId) {
    return undefined;
  }

  return getProxyVoteTaskPath({ kind: 'detail', keys: { taskId } });
}
